import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from './components/Header';
import SearchForm from './components/SearchForm';
import DealList from './components/DealList';
import Footer from './components/Footer';
import './Home.css';
import FlightLoadingScreen from './components/FlightLoadingScreen';


function Home() {
  const [flights, setFlights] = useState([]);
  const [hotels, setHotels] = useState([]);
  const [loading, setLoading] = useState(true); // 👈 Add loading state

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Simulate a delay for animation effect (optional)
        setTimeout(() => setLoading(false), 1000); // 2 sec delay
      } catch (err) {
        console.error("Error fetching data:", err);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <FlightLoadingScreen />; // 👈 Show loading screen
  }

  return (
    <div style={{ fontFamily: 'Arial' }}>
      <div className="app-wrapper">
       
        <Header />
        <div>
          <SearchForm />
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default Home;
